import { useEffect, useState } from "react";

export function useTearsheetManager(storageKey = "profiler_tearsheets") {
    const [openTearSheets, setOpenTearSheets] = useState(() => {
        try { return JSON.parse(localStorage.getItem(storageKey)) || []; }
        catch { return []; }
    });
    const [zOrder, setZOrder] = useState([]);

    useEffect(() => {
        localStorage.setItem(storageKey, JSON.stringify(openTearSheets));
    }, [openTearSheets, storageKey]);

    const closeSheet = (id, type) => {
        setOpenTearSheets(prev => prev.filter(s => !(s.id === id && s.type === type)));
        setZOrder(z => z.filter(zid => zid !== `${type}-${id}`));
    };

    const openSheet = (type, id, title) => {
        setOpenTearSheets(prev => {
            const already = prev.find(s => s.id === id && s.type === type);
            if (already) return prev.map(s => (s.id === id && s.type === type ? { ...s, minimized: false } : s));
            setZOrder(z => [...z, `${type}-${id}`]);
            return [...prev, { id, type, title, minimized: false }];
        });
    };

    const minimizeSheet = (id, type) => {
        setOpenTearSheets(prev => prev.map(s => (s.id === id && s.type === type ? { ...s, minimized: true } : s)));
    };

    const restoreSheet = (id, type) => {
        setOpenTearSheets(prev => prev.map(s => (s.id === id && s.type === type ? { ...s, minimized: false } : s)));
        setZOrder(z => [...z, `${type}-${id}`]);
    };

    const focusSheet = (id, type) => {
        setZOrder(prev => [...prev.filter(zid => zid !== `${type}-${id}`), `${type}-${id}`]);
    };

    const clearAllSheets = () => {
        setOpenTearSheets([]);
        setZOrder([]);
        localStorage.removeItem(storageKey);
    };

    return { openTearSheets, zOrder, openSheet, closeSheet, minimizeSheet, restoreSheet, focusSheet, clearAllSheets };
}
